<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex flex-column flex-md-row align-items-start justify-content-md-between">
        <div class="mb-0">
          <h1 class="page-title">États de santé</h1>
          <h2 class="page-subtitle">Total : {{ totalCount }}</h2>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn" class="text-nowrap">
          <plus-icon size="18" class="mr-1" /> Ajouter un état de santé
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableHealthState"
          identifier="B122TableHealthState"
          init-b122-table-url="/healthState/initB122Table"
          get-b122-table-results-url="/healthState/getB122TableResults"
          :fields="tableFields"
          @setTotalCount="setTotalCount"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        >

          <template #cell(imageName)="row">
            <div class="d-flex align-items-center">
              <img class="state-img" :src="healthStatesImagesBaseUrl+row.item.imageName" alt="Image associée à l'état" :title="row.item.imageName">
            </div>
          </template>

        </b122-table>

      </b-card>
    </b-container>

    <!-- Modal Delete -->
    <health-state-delete-modal :selectedHealthState="ui.selectedHealthState" @didDeleteHealthState="didDeleteHealthState()"></health-state-delete-modal>

  </div>
</template>

<script>

import B122Table from "../../components/b122/B122Table";
import HealthStateDeleteModal from "./HealthStateDeleteModal";

export default {

  name: 'HealthStateIndex',

  components: {
    B122Table,
    HealthStateDeleteModal
  },


  computed: {
    healthStatesImagesBaseUrl() {
      return process.env.SERVER_URL + '/assets/healthStates/'
    }
  },

  data() {
    return {

      totalCount: 0,

      tableFields: [
        {
          label: "Image",
          key: "imageName",
          sortable: false
        },
        {
          label: "Nom",
          key: "name",
          sortable: true
        },
        {
          label: "",
          key: "actions"
        }
      ],

      ui: {
        selectedHealthState: null
      }
    }
  },

  methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'HealthStateCreate'
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'HealthStateEdit',
        params: {
          healthStateId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selectedHealthState = row.item
      this.$bvModal.show('health-state-delete-modal')
    },

    didDeleteHealthState() {
      this.ui.selectedHealthState = null;
      this.$refs.B122TableHealthState.refreshTable()
    }

  }
}
</script>

<style scoped>
.state-img {
  width: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/healthState/HealthStateIndex.vue